import React, { useEffect, useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import {
    Row,
    Col,
    Button
} from "reactstrap";
import Loading from '../../Common/Loading';
import { getSessionValue,translateContent } from '../../Common/Appcommon';
import { createorUpdateActionForAgent } from './ProviderDetails';
import requestApi from '../../services/requestApi.service';

const Voicemail = ({agent_id, saveDetails, actionId, onAction}) => {

    const {
        control,
        handleSubmit,
        formState: { errors },
        trigger,
        setError,
        clearErrors
    } = useForm();

    const [voiceMailData,setVoiceMailData] = useState({});
    const [showLoader,setShowLoader] = useState(false);
    const proName = getSessionValue("agent_provider_name");

    const handelInputChange = (e) => {
        let { name, value } = e.target;
        if(name === 'action_name'){
            if(value != '' && !/^[a-zA-Z0-9_-]{1,64}$/.test(value)) {
                value = e.target.value.replace(/\s/g, ""); 
                setError("action_name", {
                    type: "manual",
                    message: translateContent("vm.action.action_name.msg"),
                });
            }else{
                clearErrors('action_name');
            }
        }
        setVoiceMailData({ ...voiceMailData, [name]: value.trim() === '' ? value.trim() : value });
    };

    const constructorVoiceMailParams = () =>{
        if(proName === 'vapi'){
            return {
                voicemailMessage: voiceMailData['voicemail']
            }
        }else if(proName === 'retell'){
            return {
                enable_voicemail_detection : true,
                voicemail_message: voiceMailData['voicemail']
            }
        }
    }

    const onSubmit = async () => {   
        const isValid = await trigger();
        if(!isValid){
            return;
        }
        let isNameEmpty = (data) => !data?.["action_name"]?.trim();
        if (isNameEmpty(voiceMailData)) {
            setError("action_name", {
                type: "manual",
                message: "Invalid Action name.",
            });
            return;
        }
        if(voiceMailData.voicemail.trim() === ''){
            setError("voicemail", {
                type: "manual",
                message: translateContent("vm.action.error.msg",{content: "voicemail"}),
            });
            return;
        }

        setShowLoader(true);
        let params = constructorVoiceMailParams(); // function name
        let response = await createorUpdateActionForAgent(proName,agent_id,params)
        if(response.issuccess){
            await saveDetails(voiceMailData,voiceMailData['action_name'],'vmail_message',onAction);
        }
        setShowLoader(false);
    };

    const getMainContent = () =>{
        return(
            <div className='w-100'>
                <Loading 
                    mainContent = {
                        <>
                            <div className='w-100 p-0 agency-details'>
                                <Row className='mt-1'>
                                    <Col md={12} className='field-section'>
                                        <label className={'form-label'} htmlFor="action_name">Action name</label>
                                        <Controller
                                            name="action_name"
                                            control={control}
                                            rules={{ required: voiceMailData.action_name === undefined || voiceMailData.action_name === null || voiceMailData.action_name === "" ? "Please provide Action Name": false }}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        name="action_name"
                                                        id="action_name"
                                                        placeholder='e.g. call back'
                                                        value={voiceMailData.action_name}
                                                        autoComplete={"off"}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            handelInputChange(e);
                                                        }}
                                                        className={`form-control ${errors.action_name ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.action_name && <em className={`error invalid-feedback`}>{errors.action_name.message}</em>}
                                    </Col>
                                </Row>
                                <Row className='mt-1'>
                                    <Col md={12} className='field-section'>
                                        <label className={'form-label'} htmlFor="voicemail">When should the Voicemail?</label>
                                        <Controller
                                            name="voicemail"
                                            control={control}
                                            rules={{ required: voiceMailData.voicemail === undefined || voiceMailData.voicemail === null || voiceMailData.voicemail === "" ? "Please provide voicemail": false }}
                                            render={({ field }) => {
                                                return (
                                                    <textarea
                                                        {...field}
                                                        id="voicemail"
                                                        name="voicemail"
                                                        value={voiceMailData.voicemail}
                                                        placeholder="e.g. Hey, can you please call back? Thanks!"
                                                        className={`form-control ${errors.voicemail ? "is-invalid" : ""}`}
                                                        rows="3"
                                                        maxLength="1000"
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            handelInputChange(e);
                                                        }}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.voicemail && <em className={`error invalid-feedback`}>{errors.voicemail.message}</em>}
                                    </Col>
                                </Row>          
                                {
                                    proName !== 'bland' && (
                                        <Row className='mt-3'>
                                            <Col md={12} className='d-flex justify-content-end'>
                                                <Button className="container-footer-save theme-bg-g" type="submit" onClick={handleSubmit(onSubmit)}>
                                                    {actionId ? "Update Action" : (<><i className="fi fi-rs-plus"></i> Add Action</>)}
                                                </Button>
                                            </Col>
                                        </Row>
                                    )
                                }  
                            </div>
                        </>
                    }
                    showLoader = {
                        showLoader
                    }
            />
            </div>
            
        )
    }

    const getActionDetails = async() =>{
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "GET_ACTION_DETAILS",
            'agent_id': agent_id,
            'actionid':actionId,
        };
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data;
            setVoiceMailData(data)
        }

    }
    useEffect(() => {
        const fetchActionDetails = async () => {
            if (agent_id !== undefined || actionId !== undefined) {
                await getActionDetails();
            }
        };
        fetchActionDetails();
    }, [agent_id, actionId]);


    return (getMainContent()); 
};

export default Voicemail;
